import { initializeApp } from 'firebase/app';
import { getAuth, signOut } from 'firebase/auth';
import { catchError } from '@utils/sentry';
import { appName } from '@utils/localStorageHelpers';
import { getRuntimeConfigSync } from '@utils/runtimeConfig';
export let firebaseInstance;
/**
 * Initialize Firebase with runtime configuration
 * Gets configuration from runtime config automatically
 * @returns FirebaseInstance or undefined if initialization fails
 */
export const initializeFirebase = () => {
    try {
        const config = getRuntimeConfigSync();
        const firebaseConfig = {
            apiKey: config.FIREBASE_API_KEY,
            authDomain: config.FIREBASE_API_DOMAIN,
        };
        const app = initializeApp(firebaseConfig, { name: appName });
        const auth = getAuth(app);
        firebaseInstance = {
            firebaseApp: app,
            fireBaseAuth: auth,
        };
        return firebaseInstance;
    }
    catch (error) {
        catchError({ title: 'Firebase initialization', error: error });
    }
};
export const getFirebaseIdToken = async () => {
    const auth = firebaseInstance?.fireBaseAuth;
    // Routes reachable without an auth token (e.g. /public-assessment) can fire a GraphQL request
    // before Auth/saga.ts's initializeWorker has called initializeFirebase() — every request goes
    // through this link regardless of route, so treat "not yet initialized" as "not authenticated"
    // instead of throwing.
    if (!auth) {
        return '';
    }
    await auth.authStateReady();
    const currentUser = auth?.currentUser;
    let idToken = '';
    if (typeof currentUser?.getIdToken === 'function') {
        idToken = await currentUser?.getIdToken();
    }
    return idToken;
};
export const firebaseLogout = async () => {
    const auth = firebaseInstance?.fireBaseAuth;
    await signOut(auth);
};
export default initializeFirebase;
